export default function Projects() {
  const projects = [
    {
      title: 'Industria del Papel',
      description: 'Soluciones especializadas para el sector papelero con maquinaria de alta precisión y durabilidad.',
      icon: 'ri-file-paper-2-line',
    },
    {
      title: 'Sector Naval',
      description: 'Componentes y sistemas mecánicos para la industria naval con los más altos estándares de calidad.',
      icon: 'ri-ship-line',
    },
    {
      title: 'Elevación',
      description: 'Sistemas de elevación industrial diseñados para máxima seguridad y eficiencia operativa.',
      icon: 'ri-arrow-up-down-line',
    },
    {
      title: 'Componentes Offshore',
      description: 'Fabricación de componentes robustos para aplicaciones offshore en condiciones extremas.',
      icon: 'ri-oil-line',
    },
    {
      title: 'Energía',
      description: 'Soluciones para el sector energético con tecnología avanzada y sostenible.',
      icon: 'ri-flashlight-line',
    },
    {
      title: 'Minería y Bienes de Equipo',
      description: 'Equipamiento industrial para minería y maquinaria pesada de alta resistencia.',
      icon: 'ri-hammer-line',
    },
  ];

  return (
    <section id="proyectos" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Proyectos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experiencia en múltiples sectores industriales con soluciones personalizadas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${project.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {project.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {project.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
